<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card-text>
          <v-container>
            <v-row align="center" class="toolbar-row">
              <v-col cols="12" md="3">
                <v-select
                  class="ui-form-field"
                  label="Tipo de accesorio"
                  v-model="selectedTipoItem"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="transparent"
                  :items="tipoItem"
                  item-color="secondary"
                  item-text="title"
                  item-value="id"
                  hide-details
                  @change="fetchItems($event)"
                ></v-select>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" md="auto" align="right" class="d-flex align-center toolbar-action">
                <registro-item-dialog-component></registro-item-dialog-component>
              </v-col>
              <v-col cols="12" md="3" class="d-flex align-center">
                <v-text-field
                  class="search-input"
                  v-model="buscaItem"
                  rounded
                  filled
                  dense
                  hide-details
                  background-color="transparent"
                  color="secondary"
                  label="Buscar accesorio"
                  append-icon="mdi-magnify"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-data-table
                  class="primary ui-module-table"
                  :headers="headers"
                  :items="items"
                  :search="buscaItem"
                  hide-default-footer
                  calculate-widths
                >
                  <template v-slot:[`item.opciones`]="{ item }">
                    <TextButton
                      rounded
                      small
                      color="secondary"
                      class="mx-2 ui-module-btn-solid"
                      @click="openEditarItemDialog(item)"
                      >Editar accesorio</TextButton
                    >
                    <TextButton
                      rounded
                      small
                      color="secondary"
                      class="mx-2 ui-module-btn-solid"
                      @click="openHistorialMovimientosDialog(item)"
                      >Ver movimientos</TextButton
                    >
                    <registrar-movimiento-item-dialog-component
                      :id-item="item.id"
                    ></registrar-movimiento-item-dialog-component>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-col>
    </v-row>
    <editar-item-dialog-component
      :active="editarItemDialog"
      :item="selectedItem"
      @close="editarItemDialog = false"
    ></editar-item-dialog-component>
    <historial-movimientos-item-dialog-component
      :active="historialMovimientosItemDialog"
      @close="historialMovimientosItemDialog = false"
    ></historial-movimientos-item-dialog-component>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import EditarItemDialogComponent from '../../components/armeria/EditarItemDialogComponent.vue'
import HistorialMovimientosItemDialogComponent from '../../components/armeria/HistorialMovimientosItemDialogComponent.vue'
import RegistrarMovimientoItemDialogComponent from '../../components/armeria/RegistrarMovimientoItemDialogComponent.vue'
import RegistroItemDialogComponent from '../../components/armeria/RegistroItemDialogComponent.vue'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: {
    RegistroItemDialogComponent,
    RegistrarMovimientoItemDialogComponent,
    EditarItemDialogComponent,
    HistorialMovimientosItemDialogComponent,
    TextButton,
  },

  data() {
    return {
      headers: [
        { text: 'Accesorio', value: 'item', width: '30%' },
        { text: 'Opciones', value: 'opciones', align: 'center', width: '70%' },
      ],

      buscaItem: '',
      selectedTipoItem: null,

      historialMovimientosItemDialog: false,
      // listaCargadoresDialog: false,

      editarItemDialog: false,
      selectedItem: null,
    }
  },

  computed: {
    ...mapGetters('tipoItemArmeria', {
      tipoItem: 'getTipoItem',
    }),

    ...mapGetters('itemArmeria', {
      items: 'getItems',
    }),
  },

  methods: {
    ...mapActions('itemArmeria', ['fetchItems']),
    ...mapActions('movimientoItem', ['fetchMovimientoItem']),

    async openHistorialMovimientosDialog(item) {
      this.selectedItem = item
      await this.fetchMovimientoItem(item.id)

      this.historialMovimientosItemDialog = true
    },

    async openListaCargadoresDialog(calibre) {
      this.selectedCalibre = calibre
      await this.fetchCargadores(calibre.idCalibre)

      this.listaCargadoresDialog = true
    },

    openEditarItemDialog: function (item) {
      this.selectedItem = item
      this.editarItemDialog = true
    },

    getStockMunicionesByCalibre(id_calibre) {
      var stock = 0

      var filteredMuniciones = this.movimientoMunicion.filter((movimiento) => {
        return movimiento.fk_idCatCalibre == id_calibre
      })

      filteredMuniciones.forEach((movimiento) => {
        if (movimiento.fk_idcatTipoMovimiento == 1) {
          stock += movimiento.cantidad
        } else {
          stock -= movimiento.cantidad
        }
      })

      return stock
    },
  },
}
</script>

<style scoped>
.inventario-items-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

.toolbar-row {
  row-gap: 8px;
}

.toolbar-action {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* Inputs y selectores */
::v-deep .ui-form-field .v-input__slot,
::v-deep .search-input .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .ui-form-field .v-input__slot:hover,
::v-deep .search-input .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control,
::v-deep .search-input .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control,
::v-deep .search-input.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field .v-select__selection,
::v-deep .search-input input {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label,
::v-deep .search-input .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .search-input.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

/* Menu del select */
::v-deep .v-menu__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

::v-deep .v-list {
  background: transparent !important;
}

::v-deep .v-list-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.3s ease;
}

::v-deep .v-list-item:hover {
  background: rgba(108, 92, 231, 0.2) !important;
}

::v-deep .v-list-item__title {
  color: #e0e0e0 !important;
}

/* Iconos */
::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn .v-icon {
  color: #ffffff !important;
}

::v-deep .v-input__icon .v-icon {
  color: rgba(108, 92, 231, 0.7) !important;
}

::v-deep .v-input--is-focused .v-input__icon .v-icon {
  color: #6c5ce7 !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  color: #e0e0e0 !important;
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}
</style>
